import { gql } from '@apollo/client/core';

export const pageAssemblyFragment = gql`
  fragment PageAssemblyFields on PageAssembly {
    pageTitle
    slug
    text
    isProtected
    image {
      url
      title
    }
  }
`;
